import isApiError from "@insite/client-framework/Common/isApiError";
import { get, post } from "@insite/client-framework/Services/ApiService";
import { SubscribedEmailDto } from "@WhiteCap/Store/Reducer/WhiteCapReducer/OsnSubscriptionsDashboard/SubscriptionsDashboard";

export interface ApiResultModel {
    uri?: string;
    asnOrderStatusSummary?: {
        count?: number;
    };
    subscribedEmails?: SubscribedEmailDto[];
    properties?: {
        [key: string]: string;
    };
}

export interface ApplyAsnSubscriptionsApiResultModel {
    uri: string;
    customerId: string;
    subscribedEmails: SubscribedEmailDto[];
    properties: {
        [key: string]: string;
    };
}

const url = "/api/v1/asnSummary";

export async function getAsnSubscribers(customerId?: string) {
    const queryParams = customerId ? `?customerId=${customerId}` : "";
    try {
        const result = await get<ApiResultModel>(`${url}${queryParams}`, {}, {}, "no-store");
        return {
            successful: true,
            result,
        };
    } catch (error) {
        if (isApiError(error)) {
            return {
                successful: false,
                errorMessage: error.errorJson.message || "Something went wrong!",
            };
        }
        throw error;
    }
}

export async function applyAsnSubscriptionsService(
    customerId: string,
    subscribedEmails: SubscribedEmailDto[],
) {
    try {
        const result = await post<
            { customerId: string; subscribedEmails: SubscribedEmailDto[] },
            ApplyAsnSubscriptionsApiResultModel
        >(`${url}`, {
            customerId,
            subscribedEmails,
        });

        return {
            successful: true,
            result,
        };
    } catch (error) {
        if (isApiError(error)) {
            return {
                successful: false,
                errorMessage: error.errorJson.message || "Something went wrong!",
            };
        }
        throw error;
    }
}
